import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SpellLimitation,
  SpellDamageOptions
} from "@dndModels";
import { DAMAGE_TYPES } from "@dndModels/Constants";
import { DamageType } from "@dndModels/Types";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";
import CheckBox from "@components/input/CheckBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  obj: SpellDamageOptions;
  onChange: (changed: SpellDamageOptions) => void; 
  disabled: boolean;
}

export default function SpellDamageOptionsInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SpellLimitInput
          obj={obj.spell_limit}
          disabled={disabled}
          onChange={(changed: SpellLimitation) => {
            const new_obj = obj;
            new_obj.spell_limit = changed.clone();
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <CheckBox
          name="Learning"
          value={obj.learning}
          disabled={disabled}
          onChange={(changed: boolean) => {
            const new_obj = obj;
            new_obj.learning = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        { obj.learning &&
          <CheckBox
            name="Level by Level"
            value={obj.level_by_level}
            disabled={disabled}
            onChange={(changed: boolean) => {
              const new_obj = obj;
              new_obj.level_by_level = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        }
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        { obj.learning ?
          <SpellLimitInput
            obj={obj.learning_limit}
            disabled={disabled}
            onChange={(changed: SpellLimitation) => {
              const new_obj = obj;
              new_obj.learning_limit = changed.clone();
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        :
          <SelectStringBox
            name="Options"
            options={DAMAGE_TYPES}
            extra_options={["Selectable"]}
            values={obj.damage_type_options}
            disabled={disabled}
            onChange={(changed: (DamageType | "Selectable")[]) => {
              const new_obj = obj;
              new_obj.damage_type_options = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        }
      </Grid>
      { !obj.learning && obj.damage_type_options.includes("Selectable") &&
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Selectable Key"
            value={obj.selectable_key} 
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.selectable_key = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        </Grid>
      }
    </Grid>
  );
}
